import { io } from 'socket.io-client';
// import store from "@/store/store";
import ip from '../ip2';

const socketss = io(ip, {
    transports: ['websocket'],
});

export default socketss;
